import { useEffect, useState } from 'react';

const canUseDom = typeof document !== 'undefined';

const getRoot = () => {
  if (!canUseDom) {
    return null;
  }

  return (
    (document.querySelector('.mapleos-root:not([data-mapleos-portal-theme="true"])') as HTMLElement | null) ||
    (document.querySelector('.mapleos-root') as HTMLElement | null) ||
    document.documentElement
  );
};

export default function useOsDark(): boolean {
  const [isDark, setIsDark] = useState<boolean>(() => getRoot()?.classList.contains('dark') ?? false);

  useEffect(() => {
    const root = getRoot();
    if (!root) {
      return;
    }

    const update = () => setIsDark(root.classList.contains('dark'));
    update();

    const observer = new MutationObserver(update);
    observer.observe(root, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect();
  }, []);

  return isDark;
}
